import React from 'react';
import Footer from '../components/Footer';
import Nav from '../components/Nav';
import BottomNav from '../components/BottomNav';
import CalendarEmbed from '../components/CalendarEmbed';
import { Link } from 'react-router-dom';

function Calendar() {
	return (
		<div className='flex flex-col'>
			<Nav />
			<div className='bg-info text-base-100'>
				<h1 className='p-10 text-center font-heading text-2xl'>Calendar</h1>
			</div>
			<div className='bg-secondary p-10 text-center'>
				<p>
					The Marshall Music Department has a busy calendar each year filled
					with concerts, performances, field trips and other events for the
					community.
				</p>
			</div>
			<div className='hidden justify-center p-10 md:flex'>
				<CalendarEmbed />
			</div>
			<Link
				to='/'
				className='btn btn-primary btn-lg m-10 rounded-sm font-lora normal-case text-base-100 md:hidden'
			>
				View the Calendar
			</Link>
			{/* <div className='flex flex-wrap items-center justify-center gap-10 bg-accent p-10'>
				<CalendarEvent
					name={'Event 1'}
					desc='Come join us for some fun!'
					date='10/17/22'
					time='5:00pm - 7:00pm'
					url='/'
				/>
				<CalendarEvent
					name={'Event 2'}
					desc='Come join us for some fun!'
					date='10/17/22'
					time='5:00pm - 7:00pm'
					url='/'
				/>
				<CalendarEvent
					name={'Event 3'}
					desc='Come join us for some fun!'
					date='10/17/22'
					time='5:00pm - 7:00pm'
					url='/'
				/>
				<CalendarEvent
					name={'Event 4'}
					desc='Come join us for some fun!'
					date='10/17/22'
					time='5:00pm - 7:00pm'
					url='/'
				/>
			</div> */}
			<BottomNav />
			<Footer />
		</div>
	);
}
export default Calendar;
